import styled from "styled-components";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const ChartContainer = styled(FlexColumn)<{ cursorUrl: string }>`
    gap: 24px;
    height: 287px;
    &:hover {
        cursor: url(${({ cursorUrl }) => cursorUrl}), zoom-in;
    }
    .highcharts-axis-labels {
        cursor: default;
    }
`;

export const ScatterLayout = styled(FlexColumn)`
    padding: 16px 24px;
    gap: 24px;
`;

const ScatterContent = styled(FlexRow)`
    gap: 24px;
    height: 100%;
`;

const ChartWrapper = styled.div`
    width: 100%;
`;

export const LoadingWrapper = styled.div`
    padding: 16px 24px;
`;

export const NoDataWrapper = styled.div`
    height: 338px;
`;
export const Hr = styled.hr`
    margin: 0;
`;
